import clsx from "clsx";
import { GetIcon } from "../../../setup/utilities/icons";

type LabelStateBaseProps = {
  icon?: any;
  name?: any;
  width?: string;
  height?: string;
  space?: string;
  padding?: string;
  textAlign?: "center" | "start" | "end";
  textColor?: string;
  textSize?: string;
  opacity?: number;
  borderColor?: string;
};

type LabelStateTypeProps = LabelStateBaseProps & {
  type: "warning" | "info" | "danger" | "success";
  color?: any;
};

type LabelStateColorProps = LabelStateBaseProps & {
  type?: undefined;
  color: any;
};

type Props = LabelStateTypeProps | LabelStateColorProps;

const LabelState: React.FC<Props> = ({
  color,
  icon,
  name,
  width,
  height,
  space,
  padding,
  textAlign,
  textColor,
  textSize,
  opacity,
  borderColor,
  type,
}) => {
  const JSXIcon = icon ? GetIcon(icon) : null;

  const opacityHex: any = opacity
    ? Math.round((opacity * 255) / 100).toString(16)
    : 12;

  return (
    <span
      className={clsx(
        `d-flex justify-content-${textAlign || "center"} rounded`,
        space && space,
        padding ? padding : "px-4 py-2",
        typeof name === "string" && "align-items-center"
      )}
      style={{
        backgroundColor: `${
          type
            ? type === "warning"
              ? "#ff8823"
              : type === "info"
              ? "#1465f8"
              : type === "success"
              ? "#8cd769"
              : "#f7686a"
            : color
        }${opacityHex}`,
        color: type ? `var(--${type})` : textColor || color,
        border: `1px solid  ${type ? `var(--${type})` : borderColor || color}`,
        width: width || "auto",
        height: height || "auto",
        fontSize: textSize || "auto",
      }}
    >
      {JSXIcon ? (
        <JSXIcon
          size={20}
          weight="bold"
          className={clsx("mr-2", typeof name !== "string" && "mt-1")}
          color={type ? `var(--${type})` : color}
        />
      ) : null}
      {name}
    </span>
  );
};

export default LabelState;
